module.exports = __webpack_public_path__ + "static/media/birdTitle.f15a40dd.png";